import { useMemo } from 'react'

// TODO: AV-584
export const useSummaryByID = () =>
  useMemo(
    () =>
      ({ id }: { id: string }) => (
        <></>
      ),
    [],
  );
